import useAuthContext from "../../../hooks/useAuthContext";
import queryUsers from "../../../services/users/queryUsers";
import star from '../../../assets/svg/star1.svg';
import { useTranslation } from "react-i18next";

const PointsBadge = () => {
  const { user } = useAuthContext();
  const { data: userPoints, isLoading: isLoadingPoints } = queryUsers().userPoints();
  const { t } = useTranslation();

  const pointsValue = Math.round(Number(userPoints?.points ?? user?.point ?? 0));

  return (
    <div className="flex items-center border bg-yellow-100/50 border-orange-400 gap-1 rounded-full  px-3 py-2  shadow-sm ring-1 ring-primary/10 backdrop-blur-sm">
      <img src={star} alt="points" className="h-4 w-4 flex-shrink-0" />
      <span className="text-sm font-bold text-black">
        {isLoadingPoints ? (
          <span className="inline-flex gap-[3px] items-end">
            <span className="w-1 h-1 rounded-full bg-black animate-bounce [animation-delay:0ms]" />
            <span className="w-1 h-1 rounded-full bg-black animate-bounce [animation-delay:150ms]" />
            <span className="w-1 h-1 rounded-full bg-black animate-bounce [animation-delay:300ms]" />
          </span>
        ) : pointsValue}
      </span>
      <span className="text-xs font-semibold tracking-wide ">{t('header.points')}</span>
    </div>
  );
};

export default PointsBadge;
